import * as Backbone from 'backbone';
import { Util } from './util';
import { IView } from '../interfaces';
import { IRouteHandler } from '../interfaces/routeHandler';

export class Router extends Backbone.Router {
	public static NAVIGATIONS = {
		PATH: 'defaultBackboneNavigation'
	};

	private routeHandler: IRouteHandler;

	constructor(studio: IRouteHandler) {
		super({ routes: { '*path': Router.NAVIGATIONS.PATH } });

		this.routeHandler = studio;
	}

	private defaultBackboneNavigation(route: string) {
		this.routeHandler.route(Util.splitRoute(route));
	}

	/*
    * Navigate
    */
	public navigateToRoute(routes: string[]) {
		this.forceNavigate(routes ? routes.join('/') : '');
	}

	public navigateToView(view: IView) {
		this.forceNavigate(view.getPath());
	}

	public updateUrl(view: IView) {
		this.navigate(view.getPath());
	}

	private forceNavigate(
		navigationPath: string,
		options: Backbone.NavigateOptions = { trigger: true }
	) {
		this.navigate(navigationPath, options);
		if (Backbone.history.getFragment() == navigationPath) {
			Backbone.history.loadUrl();
		}
	}
}

declare global {
	export interface Window {
		router: Router;
	}
}
